import React from 'react';

import Responsive from '@/components/Responsive';
import ContentViewEvents from '@/modules/corporate/components/ContentViewEvents';

import PopupQuizPreviewDesktop from './index.desktop';
import PopupQuizPreviewMobile from './index.mobile';
import { QuizPreviewType } from './types';

const PopupQuizPreviewContainer = (props: QuizPreviewType) => {
  return (
    <>
      <ContentViewEvents
        canConsume={false}
        entityId={props.quiz.id}
        performanceStatus={props.quizPerformance?.status}
      />
      <Responsive>
        <Responsive.Default>
          <PopupQuizPreviewDesktop {...props} />
        </Responsive.Default>
        <Responsive.Mobile>
          <PopupQuizPreviewMobile {...props} />
        </Responsive.Mobile>
      </Responsive>
    </>
  );
};

export default PopupQuizPreviewContainer;
